export default __webpack_public_path__ + "static/media/sm_mega.a6c4c112.png";